import {
    mdiCheckAll,
    mdiPaperclip,
} from '@mdi/js'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {Badge} from 'swayok-react-mdb-ui-kit/components/Typography/Badge'
import type {ChatMessageData} from '../ChatsModuleTypes'

interface Props {
    message: ChatMessageData
}

// Элемент сообщения в чате.
export function ChatMessagesListItem(props: Props) {

    const renderMessage = () => {
        if (props.message.file) {
            if (props.message.file.type === 'image') {
                return (
                    <div className="pt-2">
                        <Link
                            to={props.message.file.url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={props.message.file.url}
                                alt=""
                                width={200}
                                className="mb-2 rounded-4"
                            />
                        </Link>
                        {props.message.message.length > 0 && (
                            <div className="mt-n1 text-multiline">
                                {props.message.message}
                            </div>
                        )}
                    </div>
                )
            } else {
                return (
                    <div>
                        <a
                            href={props.message.file.url}
                            target="_blank"
                            className="with-icon"
                            rel="noreferrer"
                        >
                            <Icon
                                path={mdiPaperclip}
                                color="muted"
                                className="me-2"
                            />
                            <span>{props.message.file.name}</span>
                        </a>
                        {props.message.message.length > 0 && (
                            <div className="mt-1 text-multiline">
                                {props.message.message}
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="text-multiline">
                    {props.message.message}
                </div>
            )
        }
    }

    return (
        <div
            className={clsx(
                'd-flex flex-row align-items-start mt-2 mt-sm-0',
                props.message.isAuthor ? 'justify-content-end ps-5' : 'justify-content-start pe-5'
            )}
        >
            <div
                className={clsx(
                    'chat-message mb-3 d-flex flex-column align-items-end',
                    props.message.isAuthor
                        ? 'chat-message-is-author flex-sm-row'
                        : 'chat-message-not-author flex-sm-row-reverse'
                )}
            >
                <div className="chat-message-timestamp pb-2 mx-2 text-muted flex-shrink-0 flex-row-center-vertical">
                    {props.message.isAuthor && props.message.isViewed && (
                        <Icon
                            path={mdiCheckAll}
                            size={20}
                            color="light-green"
                            className="me-2"
                        />
                    )}
                    <span>{props.message.createdAt}</span>
                </div>
                <div
                    className={clsx(
                        'position-relative d-flex align-items-start justify-content-start',
                        props.message.isAuthor ? 'flex-row-reverse' : 'flex-row'
                    )}
                >
                    {!props.message.isAuthor && (
                        <div className="flex-shrink-0 mx-2">
                            <div className="chat-message-avatar">
                                {props.message.user.name.substring(0, 1) || '?'}
                            </div>
                        </div>
                    )}
                    <div
                        className={clsx(
                            'chat-message-text py-2 px-3 rounded-5',
                            props.message.isAuthor ? 'bg-light-blue' : 'bg-gray'
                        )}
                    >
                        {renderMessage()}
                        {!props.message.isAuthor && !props.message.isViewed && (
                            <Badge
                                dot
                                color="red"
                            />
                        )}
                    </div>
                </div>

            </div>

        </div>
    )
}
